export default __webpack_public_path__ + "static/media/au_lutn.b33cf88e.svg";